import axios from "axios";
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import util from './utils/util.js';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

Bugsnag.start({
    apiKey: "c711d8a65630913a621affdc20b85758",
    appVersion: process.env.VUE_APP_VERSION,
    releaseStage: process.env.NODE_ENV,
    notifyReleaseStages: ['production', 'beta'],
    plugins: [new BugsnagPluginVue()]
  })

const bugsnagVue = Bugsnag.getPlugin('vue')
bugsnagVue.installVueErrorHandler(Vue)

axios.interceptors.request.use(req => {
    req.headers[util.h()] = util.i();
    req.headers[util.xi()] = util.xv();
    return req;
});

// if (typeof Object.assign != 'function') {
//     console.log('******fix!');
//     // Must be writable: true, enumerable: false, configurable: true
//     Object.defineProperty(Object, "assign", {
//         value: function assign(target, varArgs) { // .length of function is 2
//             'use strict';
//             if (target == null) { // TypeError if undefined or null
//                 throw new TypeError('Cannot convert undefined or null to object');
//             }
//
//             var to = Object(target);
//
//             for (var index = 1; index < arguments.length; index++) {
//                 var nextSource = arguments[index];
//
//                 if (nextSource != null) { // Skip over if undefined or null
//                     for (var nextKey in nextSource) {
//                         // Avoid bugs when hasOwnProperty is shadowed
//                         if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
//                             to[nextKey] = nextSource[nextKey];
//                         }
//                     }
//                 }
//             }
//             return to;
//         },
//         writable: true,
//         configurable: true
//     });
// }


import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

import { languages } from './locales/index.js';

const messages = Object.assign(languages);

Vue.config.productionTip = false;

// Function to get the best matching locale
function getBestMatchingLocale(browserLocale, availableLocales) {
    // First, try exact match
    if (availableLocales.includes(browserLocale)) {
        return browserLocale;
    }
    
    // Then, try language part only (e.g., 'en-US' -> 'en')
    const languageCode = browserLocale.split('-')[0];
    if (availableLocales.includes(languageCode)) {
        return languageCode;
    }
    
    // If no match found, return null (will use fallback)
    return null;
}

const availableLocales = Object.keys(messages);
const browserLocale = navigator.language;
const bestLocale = getBestMatchingLocale(browserLocale, availableLocales);

const i18n = new VueI18n({
    locale: bestLocale || 'en',
    fallbackLocale: 'en',
    messages,
    silentTranslationWarn: process.env.NODE_ENV === 'production',
    silentFallbackWarn: process.env.NODE_ENV === 'production'
});


new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');

Vue.prototype.$bugsnag = Bugsnag;